import { CourseWare } from "@vue-skuilder/courseware";
import { SustainedNoteQuestion } from "./SustainedNoteQuestion";
import { SequencedNoteReadingQuestion } from "./SequencedNoteReadingQuestion";

export const exampleCourse = new CourseWare("ExampleCourse", [
  SustainedNoteQuestion,
  SequencedNoteReadingQuestion,
]);
